import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AllowedExtension } from '@views/screens/common/types';
import type { AxiosResponse } from 'axios';

export interface GetDocumentAllowedExtensionsListRequestParams {
  moduleId: string;
}

export const getDocumentAllowedExtensionsListAPI = (params: GetDocumentAllowedExtensionsListRequestParams) => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetAllowedExtensions`,
    method: 'get',
    params,
  });
};

export type DocumentAllowedExtensionsResponse = AllowedExtension[];

export const fetchDocumentAllowedExtensionsList = async (
  params: GetDocumentAllowedExtensionsListRequestParams,
): Promise<DocumentAllowedExtensionsResponse> => {
  const response: AxiosResponse<DocumentAllowedExtensionsResponse> = await getDocumentAllowedExtensionsListAPI(params);
  return response.data;
};
